// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"global_errorMessage__2gPA-","boldText":"global_boldText__33v8F"};